'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moveSelectionToEndOfPreviousBlock = require('./utils/moveSelectionToEndOfPreviousBlock');

var _moveSelectionToEndOfPreviousBlock2 = _interopRequireDefault(_moveSelectionToEndOfPreviousBlock);

var _checklistConstants = require('./checklistConstants');

var _draftjsConstants = require('../../draftjsConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
exports.default = function (command, _ref) {
    var getEditorState = _ref.getEditorState,
        setEditorState = _ref.setEditorState;

    switch (command) {
        case _checklistConstants.COMMANDS.MOVE_SELECTION_TO_END_OF_PREVIOUS_BLOCK:
            setEditorState((0, _moveSelectionToEndOfPreviousBlock2.default)(getEditorState()));
            return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
        default:
            return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
    }
}; // Utils


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/checklist/handleKeyCommand.js
// module id = 1723
// module chunks = 0